import {cleanTokens, clearStorageCorps} from '@/util/AuthStore';

const actions = {
    loginSuccess: (draft, {tokens, user, authorities}) => {
        draft.isLogin = true;
        draft.user = user;
        draft.authorities = authorities;
        draft.tokens = tokens;

        // setTokens(tokens);
    },

    reset: draft => {
        draft.isLogin = false;
        draft.user = null;
        draft.authorities = null;

        cleanTokens();
        clearStorageCorps();
    },

    changeLayout: draft => {
        const flag = draft.isDefaultAppLayout;
        draft.isDefaultAppLayout = !flag;
    },
};

export default actions;
